require('css/components/modal.scss');

import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

class Modal extends Component {
  static defaultProps = { noClose: false }
  state = { transitioning: false }

  // TODO Moved out from the mixins file. Needs refactoring.
  componentDidMount() {
    setTimeout(() => {
      this.setState({transitioning: true});
    }, 0);
  }

  onFinished = () => {
    window.app.setModal(null);
  }

  onClose = () => {
    if (this.props.onClose) this.props.onClose();
    this.onFinished();
  }

  renderFooterButtons = () => {
    const acceptButtonClasses = classNames({
      'btn': true,
      'btn-primary': true,
      'btn-block': true,
      'btn-flat': true,
      'modal-split-button': this.props.cancel,
      'modal-button-accept': this.props.cancel,
    });

    const closeButtonClasses = classNames({
      'btn': true,
      'modal-button-cancel': true,
      'btn-block': true,
      'btn-flat': true,
      'modal-split-button': true,
    });

    return (
      <div className="modal-button-container">
        {
          this.props.onAccept &&
          <input type="submit" className={acceptButtonClasses} value={this.props.accept} onClick={() => {
            this.props.onAccept();
            this.onClose();
          }}/>
        }
        {
          this.props.cancel &&
          <input type="button" value={this.props.cancel} onClick={this.onClose} className={closeButtonClasses}/>
        }
      </div>
    );
  }

  render() {
    const dismissable = !this.props.noClose;
    const size = this.props.size ? { [`modal-${this.props.size}`]: true } : null;

    const modalClasses = {
      'app-modal': true,
      'app-modal-in': this.state.transitioning,
      ...this.props.modalClasses,
    };

    const dialogClasses = classNames({
      'modal-dialog': true,
      ...size,
      ...this.props.dialogClasses,
    });

    const contentClasses = classNames({
      'modal-content': true,
      ...this.props.contentClasses,
    });

    return (
      <div key="modal" className={classNames(modalClasses)} tabIndex="-1" onClick={dismissable && this.onClose}>
        <div className={'vertical-alignment-helper'}>
          <div className={dialogClasses} style={this.props.position}>
            <div className={contentClasses || 'modal-content'} onClick={event => event.stopPropagation()}>
              {this.props.title && <header>{this.props.title}</header>}
              {
                dismissable &&
                <button type="button" className={'close modal-close icon-close'} onClick={this.onClose} />
              }
              <div className={this.props.title ? 'modal-body' : null}>
                {this.props.children}
                {(this.props.onAccept || this.props.cancel) && this.renderFooterButtons()}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default Modal;

Modal.propTypes = {
  accept: PropTypes.string,
  cancel: PropTypes.string,
  children: PropTypes.any,
  contentClasses: PropTypes.object,
  dialogClasses: PropTypes.object,
  modalClasses: PropTypes.object,
  noClose: PropTypes.bool,
  onAccept: PropTypes.func,
  onClose: PropTypes.func,
  position: PropTypes.object,
  size: PropTypes.string,
  title: PropTypes.any,
};



// WEBPACK FOOTER //
// ./app/assets/jsx/lib/modal.jsx